export default __webpack_public_path__ + "static/media/track.0435f8fc.svg";